module.exports = __webpack_public_path__ + "fonts/chevron-left-1.svg";